module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.68817","quantity":0.02688},{"color":"#9dc4b5","label":" 2.68817- 4.66125","quantity":0.04661},{"color":"#e6efc3","label":" 4.66125- 5.49249","quantity":0.05492},{"color":"#ffe89e","label":" 5.49249- 6.76986","quantity":0.0677},{"color":"#f5af7f","label":" 6.76986- 8.99051","quantity":0.08991},{"color":"#ed6d32","label":" 8.99051-26.11977","quantity":0.2612}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_100_return_10.json
// module id = QSdC
// module chunks = 171